import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import { isUserRole } from '@/types/userStore.types'

import { useUserStore } from '@/store/user.store'

import { Loader } from '@/components/Loader/Loader'

import { useUserServiceUserControllerGetLoggedUserKey } from '@/__generated__/queries'
import { role as Roles, UserService } from '@/__generated__/requests'

export function CommonLayout() {
  const setUser = useUserStore.use.setUser()
  const setCurrentRole = useUserStore.use.setCurrentRole()
  const setIsInitialized = useUserStore.use.setIsInitialized()

  const { data, isFetched, isLoading } = useQuery({
    queryFn: () => UserService.userControllerGetLoggedUser(),
    queryKey: [useUserServiceUserControllerGetLoggedUserKey],
    retry: false,
    staleTime: 0,
  })

  useEffect(() => {
    if (!isFetched) return

    if (data) {
      setUser(data)

      const role = data.roles?.includes(Roles.EMPLOYEE)
        ? Roles.EMPLOYEE
        : (data.roles?.[0] ?? null)

      setCurrentRole(role && isUserRole(role) ? role : null)
    }

    setIsInitialized(true)
  }, [data, isFetched, setCurrentRole, setUser, setIsInitialized])

  if (isLoading) {
    return <Loader />
  }

  return <Outlet />
}
